import { CommonModule, DatePipe } from '@angular/common';
import { Component, ViewChild } from '@angular/core';
import { RouterModule } from '@angular/router';
import { ToastComponent } from '../../../shared/toast/toast.component';
import { CustomersService } from '../../../../core/services/customer/customers.service';
import { finalize } from 'rxjs';
import { CustomerBranchListModel } from '../../../../core/models/customer/customer-branch-list.model';
import { FormsModule } from '@angular/forms';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
@Component({
  selector: 'app-branch-list',
  standalone: true,
  imports: [
    FormsModule,
    CommonModule,
    DatePipe,
    RouterModule,
    ToastComponent,
    TranslateModule,
  ],
  templateUrl: './branch-list.component.html',
  styleUrl: './branch-list.component.scss',
  providers: [DatePipe],
})
export class BranchListComponent {
  @ViewChild(ToastComponent) toastComponent!: ToastComponent;

  customerBranches: CustomerBranchListModel[] = [];
  totalBranches: number = 0;
  totalPage: number = 0;
  pageSize: number = 10;
  pageSizes = [10, 25, 50, 100];
  currentPage: number = 1;
  branchListLoading: boolean = true;
  showToast: boolean = false;
  toastMessage: string = '';
  toastType: 'success' | 'error' = 'success';
  deleteModalId: string = '';
  filterForm = {
    name: '',
    customerCode: null,
    startCreatedDate: null as string | null,
    endCreatedDate: null as string | null,
  };
  maxDate: string;
  customerCodes: any = [];

  constructor(
    private customersService: CustomersService,
    private datePipe: DatePipe,
    private translate: TranslateService
  ) {
    const today = new Date();
    this.maxDate = today.toISOString().split('T')[0];
  }

  ngOnInit(): void {
    this.getBranchList(this.currentPage, this.pageSize);
    this.getCustomerCodes();
  }

  filterBranchList(e: Event) {
    e.preventDefault();

    if (this.filterForm.startCreatedDate) {
      const transformedDate = new Date(this.filterForm.startCreatedDate);
      if (!isNaN(transformedDate.getTime())) {
        this.filterForm.startCreatedDate = this.datePipe.transform(
          transformedDate,
          'dd-MM-yyyy'
        );
      }
    }

    if (this.filterForm.endCreatedDate) {
      const transformedDate = new Date(this.filterForm.endCreatedDate);
      if (!isNaN(transformedDate.getTime())) {
        this.filterForm.endCreatedDate = this.datePipe.transform(
          transformedDate,
          'dd-MM-yyyy'
        );
      }
    }

    this.getBranchList(1, this.pageSize, this.filterForm);
  }
  getBranchList(page: number, size: number, filters?: any): void {
    this.branchListLoading = true;
    this.customersService
      .customerBranchList(page, size, filters)
      .pipe(
        finalize(() => {
          this.branchListLoading = false;
        })
      )
      .subscribe({
        next: (res) => {
          this.customerBranches = res.items;
          this.totalBranches = res.count;
          this.totalPage = res.pages;
          this.pageSize = res.size;
          this.currentPage = page;
        },
        error: () => {
          this.toastMessage =
            'Error occured while getting the customer branch list.';
          this.toastType = 'error';
          setTimeout(() => {
            this.displayToast(true, this.toastMessage, this.toastType);
          }, 0);
        },
      });
  }
  getCustomerCodes() {
    this.customersService.allCustomerCodes().subscribe({
      next: (res) => {
        this.customerCodes = res;
      },
      error: () => {},
    });
  }

  clearFilters(): void {
    this.filterForm.name = '';
    this.filterForm.startCreatedDate = null;
    this.filterForm.endCreatedDate = null;
    this.getBranchList(this.currentPage, this.pageSize);
  }

  changePage(page: number): void {
    if (page > 0 && page <= this.totalPage) {
      this.getBranchList(page, this.pageSize, this.filterForm);
    }
  }

  changePageSize(event: Event): void {
    const selectElement = event.target as HTMLSelectElement;
    const size = Number(selectElement.value);
    this.pageSize = size;
    this.currentPage = 1;
    this.getBranchList(this.currentPage, this.pageSize, this.filterForm);
  }

  deleteCustomerBranch(id: string): void {
    if (id) {
      this.customersService
        .deleteCustomerBranch(id)
        .pipe(
          finalize(() => {
            this.showToast = true;
          })
        )
        .subscribe({
          next: () => {
            this.toastMessage = 'Branch has been deleted.';
            this.toastType = 'success';
            setTimeout(() => {
              this.displayToast(true, this.toastMessage, this.toastType);
            }, 0);
            this.getBranchList(1, this.pageSize, this.filterForm);
          },
          error: () => {
            this.toastMessage = 'Error occured while deleting the branch.';
            this.toastType = 'error';
            setTimeout(() => {
              this.displayToast(true, this.toastMessage, this.toastType);
            }, 0);
          },
        });
    }
  }

  displayToast(show: boolean, message: string, type: string | any): void {
    this.showToast = show;
    this.toastMessage = message;
    this.toastType = type;
  }
}
